import Brand from './brand';

export * from './brand';

export default Brand;
